export const DEVICES_WITTHOUT_HISTORY_CHARTS = [
  'VisioNize box 1',
  'VisioNize box 2',
  'VisioNize sense gateway router',
];

export const DEVICES_WITHOUT_PARAMETERS = [
  'VisioNize box 1',
  'VisioNize box 2',
  'VisioNize sense gateway router',
];
